{
  "success": {
    "analyses/setMovable": "Η ανάλυση ενημερώθηκε",
    "analyses/moveIntoPlan": "Η ανάλυση μετακινήθηκε επιτυχώς στο πλάνο",
    "analyses/remove": "Η ανάλυση αποπρογραμματίστηκε επιτυχώς",
    "analysisDefinitions/create": "Νέος ορισμός ανάλυσης προστέθηκε",
    "analysisDefinitions/edit": "Ο ορισμός ανάλυσης επεξεργάστηκε",
    "analysisDefinitions/remove": "Ο ορισμός ανάλυσης διαγράφηκε",
    "analysisDraft/create": "Νέο προσχέδιο ανάλυσης προστέθηκε",
    "analysisDraft/edit": "Το προσχέδιο ανάλυσης επεξεργάστηκε",
    "samples/delete-unlocked": "Όλα τα μη προγραμματισμένα δείγματα διαγράφηκαν",
    "assets/remove": "Το όργανο διαγράφηκε επιτυχώς",
    "assets/create": "Νέο όργανο προστέθηκε",
    "assets/edit": "Το όργανο επεξεργάστηκε",
    "competenceGroups/create": "Νέα ομάδα ικανοτήτων δημιουργήθηκε επιτυχώς",
    "competenceGroups/edit": "Η ομάδα ικανοτήτων επεξεργάστηκε επιτυχώς",
    "competenceGroups/remove": "Η ομάδα ικανοτήτων διαγράφηκε επιτυχώς",
    "iap/run": "Το IAP εκτελέστηκε επιτυχώς",
    "iap/runFillInSamples": "Τα δείγματα συμπληρώθηκαν επιτυχώς",
    "integrationSheets/createActionSheet": "Το φύλλο προστέθηκε",
    "integrationSheets/createProjectTemplateSheets": "Το φύλλο προστέθηκε",
    "integrationSheets/createSampleSheet": "Το φύλλο προστέθηκε",
    "integrationSheets/editActionSheet": "Το φύλλο επεξεργάστηκε",
    "integrationSheets/editProjectTemplateSheet": "Το φύλλο επεξεργάστηκε",
    "integrationSheets/editSampleSheet": "Το φύλλο επεξεργάστηκε",
    "integrationSheets/removeActionSheet": "Το φύλλο διαγράφηκε",
    "integrationSheets/removeProjectTemplateSheet": "Το φύλλο διαγράφηκε",
    "integrationSheets/removeSampleSheet": "Το φύλλο διαγράφηκε",
    "integrationSheets/saveSapConversionSheet": "Το φύλλο Εισαγωγής Έργου αποθηκεύτηκε",
    "members/create": "Το μέλος προστέθηκε",
    "members/createAsAdmin": "Το μέλος προστέθηκε",
    "members/edit": "Το μέλος επεξεργάστηκε",
    "members/archive": "Το μέλος αρχειοθετήθηκε",
    "projectActions/editPlanned": "Η ενέργεια έργου επεξεργάστηκε",
    "projectActions/move": "Η ενέργεια έργου τοποθετήθηκε στο πρόγραμμα",
    "projectActions/setMovable": "Η ενέργεια έργου ενημερώθηκε",
    "projectActions/setLocation": "Η τοποθεσία ενημερώθηκε",
    "projectActions/setLocationUnplanned": "Η τοποθεσία ενημερώθηκε",
    "projectActions/editUnplanned": "Η μη προγραμματισμένη ενέργεια έργου επεξεργάστηκε",
    "projectActions/removePlanned": "Το έργο αποπρογραμματίστηκε",
    "projects/create": "Νέο έργο προστέθηκε",
    "projects/edit": "Το έργο ενημερώθηκε",
    "projects/remove": "Το έργο διαγράφηκε",
    "projects/delete-unplanned": "Όλα τα μη προγραμματισμένα έργα διαγράφηκαν",
    "projects/lockProject": "Το έργο κλειδώθηκε",
    "projects/unlockProject": "Το έργο ξεκλειδώθηκε",
    "projectTemplates/create": "Νέο πρότυπο έργου δημιουργήθηκε",
    "projectTemplates/createDraft": "Νέο προσχέδιο προτύπου έργου δημιουργήθηκε",
    "projectTemplates/edit": "Το πρότυπο έργου επεξεργάστηκε",
    "projectTemplates/editDraft": "Το προσχέδιο προτύπου έργου επεξεργάστηκε",
    "projectTemplates/remove": "Το πρότυπο έργου διαγράφηκε",
    "whiteTasks/remove": "Η εργασία διαγράφηκε επιτυχώς",
    "whiteTasks/create": "Νέα εργασία προστέθηκε",
    "whiteTasks/edit": "Η εργασία επεξεργάστηκε επιτυχώς",
    "whiteTasks/createRecurrence": "Η επανάληψη δημιουργήθηκε",
    "whiteTasks/removeRecurrence": "Οι επαναλαμβανόμενες εργασίες αφαιρέθηκαν",
    "teamStatus/start": "Η Λειτουργία Προσομοίωσης ενεργοποιήθηκε",
    "teamStatus/accept": "Οι αλλαγές Λειτουργίας Προσομοίωσης εφαρμόστηκαν",
    "teamStatus/discard": "Οι αλλαγές Λειτουργίας Προσομοίωσης απορρίφθηκαν",
    "customers/addCustomer": "Ο πελάτης προστέθηκε",
    "customers/editCustomer": "Ο πελάτης επεξεργάστηκε",
    "customers/deleteCustomer": "Ο πελάτης διαγράφηκε",
    "team/create-api-token": "Το token API δημιουργήθηκε",
    "team/delete-api-token": "Το token API διαγράφηκε"
  },
  "error": {
    "analyses/remove/ERROR": "Αποτυχία αποπρογραμματισμού ανάλυσης",
    "analysisDefinitions/create/ERROR": "Αποτυχία προσθήκης νέου ορισμού ανάλυσης",
    "analysisDefinitions/remove/ERROR": "Αποτυχία διαγραφής ορισμού ανάλυσης",
    "assets/remove/ERROR": "Αποτυχία διαγραφής οργάνου",
    "assets/create/ERROR": "Αποτυχία προσθήκης οργάνου",
    "auth/login/ERROR": "Αποτυχία σύνδεσης",
    "competenceGroups/create/ERROR": "Αποτυχία δημιουργίας ομάδας ικανοτήτων",
    "competenceGroups/remove/ERROR": "Αποτυχία διαγραφής ομάδας ικανοτήτων",
    "iap/run/ERROR": "Αποτυχία εκτέλεσης IAP",
    "iap/runFillInSamples/ERROR": "Αποτυχία συμπλήρωσης δειγμάτων",
    "integrationSheets/createActionSheet/ERROR": "Αποτυχία προσθήκης φύλλου",
    "integrationSheets/createProjectTemplateSheets/ERROR": "Αποτυχία προσθήκης φύλλου",
    "integrationSheets/createSampleSheet/ERROR": "Αποτυχία προσθήκης φύλλου",
    "integrationSheets/editActionSheet/ERROR": "Αποτυχία επεξεργασίας φύλλου",
    "integrationSheets/editProjectTemplateSheet/ERROR": "Αποτυχία επεξεργασίας φύλλου",
    "integrationSheets/editSampleSheet/ERROR": "Αποτυχία επεξεργασίας φύλλου",
    "integrationSheets/removeActionSheet/ERROR": "Παρουσιάστηκε σφάλμα κατά την προσπάθεια διαγραφής φύλλου",
    "integrationSheets/removeProjectTemplateSheet/ERROR": "Παρουσιάστηκε σφάλμα κατά την προσπάθεια διαγραφής φύλλου",
    "integrationSheets/removeSampleSheet/ERROR": "Παρουσιάστηκε σφάλμα κατά την προσπάθεια διαγραφής φύλλου",
    "loading/fetchAll/ERROR": "Αποτυχία φόρτωσης",
    "members/create/ERROR": "Αποτυχία προσθήκης μέλους",
    "members/createAsAdmin/ERROR": "Αποτυχία προσθήκης μέλους",
    "members/archive/ERROR": "Αποτυχία αρχειοθέτησης μέλους",
    "projectActions/move/ERROR": "Αποτυχία μετακίνησης ενέργειας στο πρόγραμμα",
    "projectActions/removePlanned/ERROR": "Αποτυχία αποπρογραμματισμού ενέργειας",
    "projectActions/setLocation/ERROR": "Αποτυχία ενημέρωσης τοποθεσίας",
    "projectActions/setLocationUnplanned/ERROR": "Αποτυχία ενημέρωσης τοποθεσίας",
    "projects/create/ERROR": "Αποτυχία προσθήκης νέου έργου",
    "projects/remove/ERROR": "Αποτυχία διαγραφής έργου",
    "projects/delete-unplanned/ERROR": "Αποτυχία διαγραφής μη προγραμματισμένων έργων",
    "projects/lockProject/ERROR": "Αποτυχία κλειδώματος ενεργειών",
    "projectTemplates/create/ERROR": "Αποτυχία δημιουργίας νέου προτύπου έργου",
    "projectTemplates/createDraft/ERROR": "Αποτυχία δημιουργίας νέου προσχεδίου προτύπου έργου",
    "projectTemplates/remove/ERROR": "Αποτυχία διαγραφής προτύπου έργου",
    "whiteTasks/remove/ERROR": "Αποτυχία διαγραφής εργασίας",
    "whiteTasks/create/ERROR": "Αποτυχία δημιουργίας",
    "teamStatus/start/ERROR": "Αποτυχία ενεργοποίησης Λειτουργίας Προσομοίωσης",
    "teamStatus/accept/ERROR": "Αποτυχία εφαρμογής αλλαγών Λειτουργίας Προσομοίωσης",
    "teamStatus/discard/ERROR": "Αποτυχία απόρριψης αλλαγών Λειτουργίας Προσομοίωσης",
    "customers/deleteCustomer/ERROR": "Δεν ήταν δυνατή η διαγραφή του πελάτη",
    "customers/addCustomer/ERROR": "Δεν ήταν δυνατή η προσθήκη του πελάτη",
    "customers/editCustomer/ERROR": "Δεν ήταν δυνατή η επεξεργασία του πελάτη",
    "team/create-api-token/ERROR": "Δεν ήταν δυνατή η δημιουργία token API",
    "team/delete-api-token/ERROR": "Δεν ήταν δυνατή η διαγραφή token API"
  },
  "adhoc": {
    "welcomeBack": "Καλώς ήρθατε πίσω!",
    "noSoundDetected": "Δεν ανιχνεύτηκε ήχος. Παρακαλώ δοκιμάστε ξανά.",
    "noMicrophoneDetected": "Δεν ανιχνεύτηκε μικρόφωνο. Παρακαλώ δοκιμάστε ξανά.",
    "iapRunning": "Μια στιγμή — το IAP για την ομάδα σας εκτελείται",
    "failedDiscardNotLoggedOut": "Αποτυχία απόρριψης αλλαγών. Δεν αποσυνδεθήκατε!",
    "cannotDragRecurrentTask": "Δεν μπορείτε να σύρετε και να αποθέσετε μια επαναλαμβανόμενη γκρι εργασία",
    "cannotMoveImportedTasks": "Δεν μπορείτε να μετακινήσετε εισαγόμενες εργασίες",
    "noCheckboxesSelected": "Δεν έχουν επιλεγεί πλαίσια ελέγχου",
    "analysisUpdatedRefresh": "Η ανάλυση ενημερώθηκε, παρακαλώ ανανεώστε",
    "analysisUpdatedByAnotherUser": "Η ανάλυση ενημερώθηκε από άλλον χρήστη, παρακαλώ ανανεώστε",
    "copiedToClipboard": "Αντιγράφηκε στο πρόχειρο",
    "couldNotCopyToClipboard": "Δεν ήταν δυνατή η αντιγραφή στο πρόχειρο",
    "chooseFirstAction": "Παρακαλώ επιλέξτε το πρώτο {{itemType}}",
    "chooseSecondAction": "Παρακαλώ επιλέξτε το δεύτερο {{itemType}}",
    "chooseTwoDifferent": "Παρακαλώ επιλέξτε δύο διαφορετικά {{itemType}}",
    "constraintConflicts": "Αυτός ο περιορισμός συγκρούεται με υπάρχοντες",
    "sampleCreated": "Το δείγμα δημιουργήθηκε",
    "sampleDeleted": "Το δείγμα διαγράφηκε",
    "samplesUpdated": "Τα δείγματα ενημερώθηκαν",
    "sampleMarkedDone": "Το δείγμα επισημάνθηκε ως ολοκληρωμένο",
    "memberPermissionsChanged": "Τα δικαιώματα μέλους άλλαξαν",
    "chooseUniqueName": "Παρακαλώ επιλέξτε μοναδικό όνομα",
    "fillRequiredFields": "Παρακαλώ συμπληρώστε τα απαιτούμενα πεδία",
    "couldNotDetermineSampleIdDone": "Δεν ήταν δυνατός ο προσδιορισμός του ID δείγματος για επισήμανση ως ολοκληρωμένου",
    "couldNotDetermineSampleIdDelete": "Δεν ήταν δυνατός ο προσδιορισμός του ID δείγματος για διαγραφή",
    "couldNotDetermineSampleIdDeleteMissing": "Δεν ήταν δυνατός ο προσδιορισμός του ID δείγματος για διαγραφή — λείπουν δεδομένα. Ελέγξτε την κονσόλα για λεπτομέρειες.",
    "anErrorOccurred": "Παρουσιάστηκε Σφάλμα",
    "selectFileBeforeSubmitting": "Παρακαλώ επιλέξτε τουλάχιστον ένα αρχείο πριν υποβάλετε",
    "helpPageUpdated": "Η σελίδα βοήθειας ενημερώθηκε",
    "processingStarted": "Η επεξεργασία ξεκίνησε",
    "failedLoadingIcalFiles": "Αποτυχία φόρτωσης αρχείων iCalendar",
    "unsortBeforePasting": "Παρακαλώ αναιρέσετε την ταξινόμηση του πίνακα πριν επικολλήσετε πολλαπλά κελιά.",
    "fillAllRequiredFields": "Παρακαλώ συμπληρώστε όλα τα απαιτούμενα πεδία",
    "unsavedChangesConfirmLeave": "Έχετε μη αποθηκευμένες αλλαγές. Για να επιβεβαιώσετε ότι θέλετε να φύγετε, πατήστε ξανά το κουμπί πίσω.",
    "provideSheetName": "Παρακαλώ δώστε Όνομα Φύλλου",
    "sheetNameAlreadyExists": "Υπάρχει ήδη φύλλο με αυτό το όνομα",
    "provideSheetType": "Παρακαλώ δώστε Τύπο Φύλλου",
    "didNotSpellDeleteProperly": "Δεν πληκτρολογήσατε σωστά τη ΔΙΑΓΡΑΦΗ",
    "domainMustStartWithAt": "Ο τομέας πρέπει να ξεκινά με '@'",
    "fillOutRequiredFields": "Παρακαλώ συμπληρώστε τα απαιτούμενα πεδία",
    "selectValidDates": "Παρακαλώ επιλέξτε έγκυρες ημερομηνίες",
    "noIapModeSelected": "Δεν επιλέχθηκε λειτουργία IAP. Παρακαλώ επιλέξτε μια λειτουργία.",
    "oneCollaboratorForWorkday": "Μπορεί να επιλεγεί μόνο ένας συνεργάτης κατά την επισήμανση ολόκληρης εργάσιμης ημέρας",
    "fillRequiredDateTimeFields": "Παρακαλώ συμπληρώστε όλα τα απαιτούμενα πεδία ημερομηνίας και ώρας",
    "endMustBeAfterStart": "Το τέλος της εργασίας πρέπει να είναι μετά την έναρξη",
    "recurrencesCannotExceed365": "Ο αριθμός επαναλήψεων δεν μπορεί να είναι μεγαλύτερος από 365",
    "pleaseFillNumberAndInterval": "Παρακαλώ συμπληρώστε τον αριθμό και το διάστημα επαναλήψεων",
    "pleaseFillNumberOfRecurrences": "Παρακαλώ συμπληρώστε τον αριθμό επαναλήψεων",
    "pleaseFillIntervalOfRecurrences": "Παρακαλώ συμπληρώστε το διάστημα επαναλήψεων",
    "pleaseFillAllPeriodFields": "Παρακαλώ συμπληρώστε όλα τα πεδία περιόδου",
    "pleaseSelectReportType": "Παρακαλώ επιλέξτε τουλάχιστον έναν τύπο αναφοράς",
    "reportEmptyInInterval": "Το {{fileName}} είναι κενό στο δεδομένο διάστημα",
    "noSoundDetected": "Δεν ανιχνεύτηκε ήχος. Παρακαλώ δοκιμάστε ξανά.",
    "noMicrophoneDetected": "Δεν ανιχνεύτηκε μικρόφωνο. Παρακαλώ δοκιμάστε ξανά.",
    "promptTooLong": "Το prompt είναι πολύ μακρύ (μέγιστο 1200 χαρακτήρες)",
    "nameTooLong": "Το όνομα είναι πολύ μακρύ (μέγιστο 100 χαρακτήρες)"
  }
}
